import React, { Component } from 'react'
import { translate } from 'react-polyglot'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { reset } from 'redux-form'

import { settingsActions } from 'features/settings'

import { Button, Confirm, Modal, Loader } from 'components'

import ProfileSettingsForm from './ProfileSettingsForm'
import ChangePasswordForm from './ChangePasswordForm'

class ProfilePage extends Component {
	constructor(props) {
		super(props)

		this.state = {
			passwordModalOpen: false,
		}

		this.timer = null
	}

	componentDidMount() {
		this.props.getProfile()

		// Reset loading state
		this.props.setLoadingState(true)

		window.addEventListener('beforeunload', this.beforeUnload)
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.beforeUnload)
	}

	beforeUnload = event => {
		if (!this.timer) return

		const confirmationMessage = this.ON_LEAVE_MESSAGE

		event.returnValue = confirmationMessage // Gecko, Trident, Chrome 34+

		return confirmationMessage
	}

	togglePasswordModal = () => {
		const { passwordModalOpen } = this.state

		this.setState({ passwordModalOpen: !passwordModalOpen })

		this.props.reset('changePassword')
	}

	handleProfileSettingsSubmit = values => {
		clearTimeout(this.timer)

		this.timer = setTimeout(() => {
			const { updateProfile } = this.props
			const {
				firstName,
				lastName,
				// theme,
			} = values

			updateProfile({
				firstName,
				lastName,
				// theme: theme ? 'dark' : 'light',
			})

			this.timer = null
		}, 500)
	}

	handleChangePasswordSubmit = values => {
		const { updatePassword } = this.props
		const { currentPassword, newPassword } = values

		updatePassword({
			currentPassword,
			newPassword,
			callback: this.togglePasswordModal,
		})
	}

	handleChangeTheme = (e, checked) => {
		const { updateTheme } = this.props

		updateTheme({ theme: checked ? 'dark' : 'light' })
	}

	handleChangeReportSettings = (e, checked) => {
		const { updateReportSettings } = this.props

		updateReportSettings({ enabled: !!checked })
	}

	onUploadImage = event => {
		event.preventDefault()

		const { updateUserImage, t } = this.props

		const file = document.getElementById('user-image-input')

		if (file.files[0].type.match('image.*')) {
			updateUserImage(file.files[0])
		} else {
			alert(t('forms.please_select_valid_image'))
		}

		event.target.value = ''
	}

	render() {
		const {
			loading,
			userImageUploadPending,
			userImageUploadSuccessful,
			profile: { firstName, lastName, email, theme, reports, image },
			t,
		} = this.props

		const { passwordModalOpen } = this.state

		if (loading) return <Loader />

		return (
			<>
				<h2>{t('settings.edit_profile')}</h2>
				<ProfileSettingsForm
					initialValues={{
						firstName,
						lastName,
						email,
						theme: theme === 'dark',
						reports,
					}}
					onSubmit={this.handleProfileSettingsSubmit}
					image={image}
					onUploadImage={this.onUploadImage}
					userImageUploadPending={userImageUploadPending}
					userImageUploadSuccessful={userImageUploadSuccessful}
					onHandleChangeTheme={this.handleChangeTheme}
					onHandleChangeReportSettings={
						this.handleChangeReportSettings
					}
					enableReinitialize="true"
				/>
				<h2>{t('forms.password')}</h2>
				<Button
					onClick={() => {
						this.togglePasswordModal()
					}}
					text={t('forms.change_password')}
					layout="ghosted"
				/>
				{/* <hr />
				<div className="grid" data-grid="wide">
					<div className="grid__item" data-grid--small="6/12">
						<h2>Account deletion</h2>
						<Confirm
							title="Really delete your account?"
							text={(
								<Fragment>
									You are about to delete your account. This action is irrevocable!
								</Fragment>
							)}
						>
							{confirm => (
								<Button
									onClick={
										confirm(() => {
											console.log('Account deleted.')
										})
									}
									text="Delete account"
									layout="ghosted"
								/>
							)}
						</Confirm>
					</div>
				</div> */}

				<Modal
					visible={passwordModalOpen}
					onClose={this.togglePasswordModal}
					title={t('forms.change_password')}
				>
					<ChangePasswordForm
						onSubmit={this.handleChangePasswordSubmit}
						handleReset={this.togglePasswordModal}
					/>
				</Modal>
			</>
		)
	}
}

const mapStateToProps = state => ({
	loading: state.settings.loading,
	profile: state.settings.profile,
	userImageUploadPending: state.settings.userImageUploadPending,
	userImageUploadSuccessful: state.settings.userImageUploadSuccessful,
})

const mapDispatchToProps = {
	setLoadingState: settingsActions.setLoadingState,
	getProfile: settingsActions.getProfileRequest,
	updateProfile: settingsActions.updateProfileRequest,
	updatePassword: settingsActions.updatePasswordRequest,
	updateTheme: settingsActions.updateThemeRequest,
	updateReportSettings: settingsActions.updateReportSettingsRequest,
	updateUserImage: settingsActions.updateUserImageRequest,
	reset,
}

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(translate()(ProfilePage))
)
